
interface DeleteConfirmationProps {
    title: string,
    content: string,
    onClose: () => void,
    onDelete: () => void;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({ onClose, onDelete, title, content }) => {
    const performDelete = () => {
        onDelete();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <div className="delete-confirmation-popup ds-pop ds-pop--center">
            <div className='d-flex align-items-center w-100 justify-content-between header'>
                <h3>{title}</h3>
            </div>
            <hr />
            <div className='content'>
                <div className='d-flex mt-4 px-0'>
                    <div className='col'>
                        <label>{content}</label>
                    </div>
                </div>
                <div className='d-flex mt-4 px-0' style={{ gap: '10px' }}>
                    <button className='blue-outline-btn w-100 round-corner-btn' onClick={handleClose}>
                        Cancel
                    </button>
                    <button className='blue-filled-btn w-100 round-corner-btn' onClick={performDelete}>
                        Confirm
                    </button>
                </div>
            </div>

        </div>

    );
};

export default DeleteConfirmation;
